import { api } from '../../../api';
import { ApiResponse, PageResult } from '../../Utilities';
import { ERPApiReadConfigurationViewModel } from '../../ViewModels';
import { GetERPApiReadConfigurationsParams } from './Params';

export class ERPApiReadConfigurationApi {
    private route = '/ERPApiReadConfiguration';

    public getERPApiReadConfiguration = (id: number): ApiResponse<ERPApiReadConfigurationViewModel> => {
        return api().get(`${this.route}/${id}`);
    };

    public getERPApiReadConfigurations = (
        params: GetERPApiReadConfigurationsParams
    ): ApiResponse<PageResult<ERPApiReadConfigurationViewModel>> => {
        return api().get(`${this.route}`, { params });
    };

    public postERPApiReadConfiguration = (
        data: ERPApiReadConfigurationViewModel
    ): ApiResponse<ERPApiReadConfigurationViewModel> => {
        return api().post(`${this.route}`, data);
    };

    public putERPApiReadConfiguration = (id: number, data: ERPApiReadConfigurationViewModel): ApiResponse<void> => {
        return api().put(`${this.route}/${id}`, data);
    };
}
